import { Alert, Switch } from "@mui/material";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons"
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons/check-box';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars/datetimepicker';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns/drop-down-list';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns/multi-select';
import React, { Component, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { isClubOwner, isClubStaff, isUser } from "../../util/UserRoles";

const EditorTemplateDesign = ({ args, players, courtNo, userId }) => {
    const { calenderConfig } = useSelector((store) => store.calendar);
    const userInfo = useSelector((store) => store.user.userInfo);
    const [toggle, setToggle] = useState(args?.IsAllDay);
    const [playerData, setPlayerData] = useState([]);
    const [isFree, setIsFree] = useState(false);
    const [maxPlayerWarning, setMaxPlayerWarning] = useState('');
    const handleToggle = () => {
        setToggle(!toggle)
    }

    //validation prevent removing of logged in user
    const onRemoving = (args) => {
        if (args.item.getAttribute('data-value') === userId) {
            args.cancel = true;
        }
    }
    const onSelect = (e) => {
        let currentPlayers = document.querySelector('#Player').ej2_instances[0].value;
        if ((isClubOwner(userInfo) || isClubStaff(userInfo)) && currentPlayers.length > 0) {
            setMaxPlayerWarning("At most, you can choose just one player.");
            e.cancel = true;
        } else if ((isUser(userInfo)) && currentPlayers.length > 7) {
            setMaxPlayerWarning("Only a maximum of eight players may be added.");
            e.cancel = true;
        }else{
            setMaxPlayerWarning('');
        }
    }

    useEffect(() => {
        if (isUser(userInfo)) {
            if (args.Player) {
                setPlayerData(args.Player);

            } else {
                setPlayerData([userId]);
            }
        }
        if (args?.IsFree !== undefined) {
            setIsFree(args.IsFree);
        }
    }, [])

    const onFiltering=(args)=>{
        
        
    }


    const fieldsForPlayers = { text: 'name', value: 'id' };
    const fieldsForCourt = { text: 'courtNumber', value: 'id' };

    return (
        <div>
           {maxPlayerWarning !== '' &&
           <Alert sx={{width:'88%'}} variant="outlined" severity="error" >
                {maxPlayerWarning}
            </Alert>}
            <table className='custom-event-editor' width={{ width: '100%' }}>
                <tbody>
                    <tr>
                        <td data-testid="court-number-label" className='e-textlabel'>Court Name</td>
                        <td>
                            <DropDownListComponent className='e-field' id='CourtNumber' fields={fieldsForCourt} dataSource={courtNo} placeholder='choose court no' data-name='CourtNumber' value={args?.CourtNumber || null}></DropDownListComponent>
                        </td>
                    </tr>
                    <tr>
                        <td data-testid="players-name-label" className='e-textlabel'>Players Name</td>


                        <td>
                            <MultiSelectComponent
                                className='e-field'
                                id='Player'
                                dataSource={players}
                                fields={fieldsForPlayers}
                                placeholder='choose player'
                                data-name='Player'
                                mode='Box'
                                select={onSelect}
                                allowFiltering={true}
                                value={playerData}
                                removing={onRemoving}
                                // filtering={onFiltering}
                            >
                            </MultiSelectComponent>
                        </td>
                    </tr>
                    <tr style={{ visibility: toggle ? 'hidden' : 'visible' }}>
                        <td data-testid="dateTimePickerFromLabel" className='e-textlabel'>From</td>
                        <td>
                            <DateTimePickerComponent data-testid="dateTimePickerFrom" className='e-field' id='StartTime' data-name='StartTime' step={Number(calenderConfig?.interval)} value={args?.StartTime || args?.StartTime}>
                            </DateTimePickerComponent>
                        </td>
                    </tr>
                    <tr style={{ visibility: toggle ? 'hidden' : 'visible' }}>
                        <td data-testid="dateTimePickerToLabel" className='e-textlabel'>To</td>
                        <td>
                            <DateTimePickerComponent data-testid="dateTimePickerTo" className='e-field' id='EndTime' data-name='EndTime' step={Number(calenderConfig?.interval)} value={args?.EndTime || args?.EndTime}>
                            </DateTimePickerComponent>
                        </td>
                    </tr>
                    <tr>
                        <td data-testid="isallday-label" className='e-textlabel'>All Day</td>
                        <td>
                            <CheckBoxComponent data-testid="isallday" onClick={handleToggle} id='IsAllDay' className='e-field' data-name='IsAllDay' checked={args?.IsAllDay}>
                            </CheckBoxComponent>
                        </td>
                    </tr>

                    <tr>
                        <td data-testid="subject-container" style={{ visibility: 'hidden', position: 'absolute' }}>
                            <input type="text" data-testid="subject" name="Subject" id="Subject" defaultValue={'Reserved'} className='e-field e-input' />
                        </td>
                    </tr>
                    <tr>
                        <td data-testid="description-label" className='e-textlabel'>Description</td>
                        <td>
                            <textarea id='reservation_description' data-testid='description' className='e-field e-input' defaultValue={args?.Description} name='Description' rows={3} cols={50}>
                            </textarea>
                        </td>
                    </tr>

                </tbody>
            </table>
            {!isUser(userInfo) &&
                <div className="reservation-isfree-button-switch">
                    <p style={{ fontSize: '1rem' }}>Is this reservation free?</p>
                    <Switch id="ReservationIsFreeBtn" onChange={(e) => setIsFree(e.target.checked)} checked={isFree} />
                </div>
            }
        </div>

    )
}

export default EditorTemplateDesign